// extracted by mini-css-extract-plugin
module.exports = {"q-number":"QNumber_q-number__1ihuy","qno-current":"QNumber_qno-current__1yFg7","qno-right":"QNumber_qno-right__1DNN6","qno-wrong":"QNumber_qno-wrong__2mjPQ"};